import * as THREE from 'three'
import { WithChildren } from '@k3/core'
import { StaticScene } from '../../three/scene'
import { CameraControls } from '../../three/utility/camera'
// import { TweakableBox } from '../../three/utility/tweakable'
import { DirectionalLight } from '../../three/light'
import { Utility } from '../../three/utility'
import { Helper } from '../../classes/helper'
import {
  AccumulativeShadows,
  RandomizedLight,
  OrbitControls,
} from '@react-three/drei'
import { PropsWithChildren, Suspense, useEffect } from 'react'
import { ReactJSXElement } from '@emotion/react/types/jsx-namespace'
import { useMontage } from '../../context/montage.context'
import { HouseLight } from '../light/HouseLight'
interface Props {
  children: React.ReactNode
}
export const Layout = ({ children }: Props): JSX.Element => {
  const { ego, night } = useMontage()
  const extrudedRound = new THREE.BoxGeometry(0.08, 0.06, 0.08)

  return (
    <>
      <Utility orbitControls />
      {!night?.night && (
        <DirectionalLight position={[10, 15, 20]} intensity={1} />
      )}
      {ego?.ego && (
        <pointLight position={[0, 1, -3.5]} power={10} decay={2} distance={5} />
      )}
      {night?.night && <HouseLight />}
      {night?.night && <hemisphereLight intensity={0.05} color="#eaeaea" />}
      {night?.night && (
        <DirectionalLight position={[10, 8, 12]} intensity={0.03} />
      )}
      {children}
      <StaticScene />
      <CameraControls />
    </>
  )
}
